export default __webpack_public_path__ + "static/media/lining13.45f1769d.jpg";